import { http } from "@/composable/httpService";
import { useHandleErrorStatus } from "@/composable/useHandleErrorStatus";
import { defineStore } from "pinia";
import { ref } from "vue";
import { computed } from "vue";

export const useHomeAvailableContentStore = defineStore(
  "homeAvailableContentStore",
  () => {
    const contents = ref([]);
    const loadingContents = ref(false);
    const page = ref(1);
    const perPage = ref(10);
    const initialLoading = ref(true);
    const isLoadMore = ref(true);
    const showCourses = ref(false);
    const categoryName = ref("");
    const loadingCategoryList = ref(false);
    const categoryList = ref([]);
    const search = ref("");
    const selectedCategory = ref(null);

    const filterContents = computed(() => {
      const query = search.value;
      if (query) {
        return contents.value.filter((content) =>
          content.name.toLowerCase().includes(query.toLowerCase())
        );
      }

      return contents.value;
    });

    const params = computed(() => {
      return {
        page: page.value,
        per_page: perPage.value,
      };
    });

    const handleFetchContents = async (refreshArray = false, showAll = false) => {
      try {
        if (refreshArray) {
          contents.value = [];
        }
        loadingContents.value = true;
        const { data } = await http().get(
          "/v3/courses/categories?is_available=true&show_courses=false&assigned_category=true&show_all=" + showAll,
          { params: params.value }
        );
        contents.value = data;
      } catch (error) {
        useHandleErrorStatus(error);
      } finally {
        loadingContents.value = false;
        initialLoading.value = false;
      }
    };

    const handleFetchCourses = async (id) => {
      try {
        loadingCategoryList.value = true;
        const { data } = await http().get(`/v3/category/courses/${id}`);
        categoryList.value = data;
      } catch (error) {
        useHandleErrorStatus(error);
      } finally {
        loadingCategoryList.value = false;
      }
    };

    return {
      contents,
      loadingContents,
      page,
      initialLoading,
      params,
      isLoadMore,
      showCourses,
      loadingCategoryList,
      categoryList,
      filterContents,
      search,
      categoryName,
      selectedCategory,
      handleFetchCourses,
      handleFetchContents,
    };
  }
);